import { addObjRefId } from '~core';

export const addMissingObjRefIds = () => {
  for (const obj of window.canvas.getObjects()) {
    addObjRefId(obj);
  }
};
